__turbopack_export_value__({
  "link": "TextLink-module-scss-module__NcqDia__link",
});
